import ResImage from "./ResImage";
import ResText from "./ResText";
import ResCarousel from "./ResCarousel";

export default function Residential() {
  return (
    <>
      <ResImage />
      <ResText />
      <ResCarousel />
    </>
  );
}
